import AutoLoad from "@/config/enums/AutoLoadConfig"
import { useCookie } from "@/@core/composable/useCookie"
import CommonService from "@/services/CommonService"

export const useAppStore = defineStore("appStore", {
  state: () => ({
    lang: import.meta.env.VITE_LANGUAGE || "en_US",
    errorMessages: [],
    listReport: JSON.parse(localStorage.getItem("listReport")) || null,
    queuingBtnList: [],
    loadingBtnList: [],
    drawNavigationOut: 0,
    autoLoad: AutoLoad,
    confirm: null,
    cachedGetRequests: {},
    newEntities: {
      shipment: 0,
      quote: 0,
      client: 0,
      provider: 0,
      accounting: 0,
      notification: 0,
    },
    yearSelected: CURRENT_YEAR,
    siteSelected: useCookie("siteSelected").value || {
      id: 6,
      acronym: "BOE",
      name: "Survey Back Office",
      siteUrl: import.meta.env.VITE_SITE_BOE,
    },
    totalNumber: 0,
  }),
  getters: {
    getList: (state) => {
      return (name) => {
        if (!state.autoLoad[name].touched) {
          state.autoLoad[name].touched = "loading"
          CommonService.autoLoad(state.autoLoad[name])
        }
        return state.autoLoad[name].list
      }
    },
    getCountries: (state) => {
      if (!state.autoLoad.getCountries.touched) {
        state.autoLoad.getCountries.touched = "loading"
        CommonService.autoLoad(state.autoLoad.getCountries)
      }
      return state.autoLoad.getCountries.list
    },
  },
  actions: {
    pushErrorMessage(message) {
      const exists = this.errorMessages.some(
        (m) =>
          (m.code === message.code && m.error === message.error) ||
          (m.status === message.status && m.detail === message.detail)
      )
      if (!exists) {
        this.errorMessages.push(message)
      }
    },
    async fetchList(name, force = false) {
      if (force) {
        this.autoLoad[name].touched = false
      }
      if (!this.autoLoad[name].touched) {
        this.autoLoad[name].touched = "loading"
        await CommonService.autoLoad(this.autoLoad[name])
      }
      if (this.autoLoad[name].touched === "loaded") {
        return this.autoLoad[name].list
      }
      await new Promise((r) => setTimeout(r, 100))
      return await this.fetchList(name)
    },
    async fetchListCached(url) {
      if (this.cachedGetRequests.hasOwnProperty(url)) {
        if (this.cachedGetRequests[url] === "loading") {
          return await new Promise((resolve) =>
            setTimeout(async () => {
              resolve(await this.fetchListCached(url))
            }, 1000)
          )
        }
        return this.cachedGetRequests[url]
      }
      this.cachedGetRequests[url] = "loading"
      const data = await $api(url)
      this.cachedGetRequests[url] = data
      return data
    },
    startLoading() {
      const lastBtn = this.queuingBtnList.pop()
      if (lastBtn) {
        const clone = JSON.parse(JSON.stringify(this.loadingBtnList))
        clone.push(lastBtn)
        this.loadingBtnList = clone
        return lastBtn
      }
      return false
    },
    endLoading(componentId) {
      if (componentId === false) return
      const index = this.loadingBtnList.findIndex((btn) => btn === componentId)
      if (index === -1) return
      const clone = JSON.parse(JSON.stringify(this.loadingBtnList))
      clone.splice(index, 1)
      this.loadingBtnList = clone
    },
    setSiteSelected(val) {
      useCookie("siteSelected").value = val
      this.siteSelected = val
    },
    getProgramSpeciality(specId) {
      const majors = this.autoLoad.getProgramMajorInUse.list
      let theSpec = null
      majors.forEach(major => {
        major.programSpecialities.forEach((spec) => {
          if (specId === spec.id) {
            theSpec = spec
            return
          }
        })
      })
      return theSpec
    },
    setListReport(report) {
      localStorage.setItem("listReport", JSON.stringify(report))
      this.listReport = report
    },
    setListReportInHomePage(report) {
      localStorage.setItem("listReport", JSON.stringify(report))
      this.listReport = report
    },
    resetListReport() {
      localStorage.removeItem("listReport")
      this.listReport = null
    },
  },
})
